import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import {
  ADDRESSEE_FORM,
  ADDRESSEE_LISTING,
  CLOSING_FORM,
  CLOSING_LISTING,
  EDITABLE_LETTER_ADD_ID_TO_SECTION,
  EDITABLE_LETTER_INITIAL_LOAD,
  EDITABLE_LETTER_REMOVE_ID_TO_SECTION,
  EDITABLE_LETTER_SET_AS_SECTION,
  EDITABLE_LETTER_UPDATED,
  LETTER_CREATED,
  LETTER_FORM,
  LETTER_LISTING_LOADED,
  LETTER_LOADED,
  LETTER_SAVE_PORTFOLIO,
  LETTER_SECTION_ITEM_TO_ADD,
  LETTER_UPDATED
} from '../../actions/resume'

const initialCreationForm = {
  title: '',
  letterType: 'cover'
}
const initialAddresseeForm = {
  contactName: '',
  company: '',
  phone: '',
  email: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  zipCode: ''
}
const initialClosingForm = {
  closing: '',
  name: ''
}
const initialDocumentFormatSelectionForm = {
  formattingId: null
}
const initialState = {
  formats: [],
  letter: {}
}
const initialLetterForm = {
  dateSent: '',
  body: '',
  salutation: ''
}
const editableLetterReducer = (state = initialState, action) => {
  switch (action.type) {
    case LETTER_SECTION_ITEM_TO_ADD:
      console.log(state, action)
      const newState3 = {
        ...state,
        [action.sectionKey]: [
          ...state[action.sectionKey]?.filter(f => f.id != action.item?.id),
          action.item
        ]
      }

      console.log('ADDING:', action, state, newState3)

      return newState3
    case EDITABLE_LETTER_INITIAL_LOAD:
      const newState = {
        ...state,
        ...action.parts
      }

      return newState
    case EDITABLE_LETTER_SET_AS_SECTION:
      return {
        ...state,
        letter: {
          ...state.letter,
          [action.sectionKey]: action.itemId
        }
      }
    case EDITABLE_LETTER_UPDATED:
      return {
        ...state,
        letter: action.letter
      }
    case EDITABLE_LETTER_ADD_ID_TO_SECTION:
      if (state.resume[action.sectionKey]?.includes(action.itemId)) {
        return state
      }

      return {
        ...state,
        letter: {
          ...state.letter,
          [action.sectionKey]: [...state.letter[action.sectionKey], action.itemId]
        }
      }
    case EDITABLE_LETTER_REMOVE_ID_TO_SECTION:
      const newState2 = {
        ...state,
        letter: {
          ...state.letter,
          [action.sectionKey]: state.letter[action.sectionKey].filter(
            i => i != action.itemId
          )
        }
      }

      return newState2
    default:
      return state
  }
}
const reducers = combineReducers({
  editableLetterReducer,
  letterCreationRequest: h2Api.restReducer(LETTER_CREATED),
  letterRenameRequest: h2Api.restReducer(LETTER_UPDATED),
  letterSavePortfolioRequest: h2Api.restReducer(LETTER_SAVE_PORTFOLIO),
  letterListingRequest: h2Api.restReducer(LETTER_LISTING_LOADED),
  letterRequest: h2Api.restReducer(LETTER_LOADED),
  letterFormRequest: h2Api.restReducer(LETTER_FORM),
  closingFormRequest: h2Api.restReducer(CLOSING_FORM),
  closingListingRequest: h2Api.restReducer(CLOSING_LISTING),
  addresseeFormRequest: h2Api.restReducer(ADDRESSEE_FORM),
  addresseeListingRequest: h2Api.restReducer(ADDRESSEE_LISTING),
  letterForm: modelReducer('jobtools.letter.letterForm', initialLetterForm),
  createForm: modelReducer('jobtools.letter.createForm', initialCreationForm),
  renameForm: modelReducer('jobtools.letter.renameForm', initialCreationForm),
  addresseeForm: modelReducer('jobtools.letter.addresseeForm', initialAddresseeForm),
  closingForm: modelReducer('jobtools.letter.closingForm', initialClosingForm),
  documentFormatSelectionForm: modelReducer(
    'jobtools.letter.documentFormatSelectionForm',
    initialDocumentFormatSelectionForm
  ),
  forms: formReducer('jobtools.letter', {
    createForm: initialCreationForm,
    renameForm: initialCreationForm,
    documentFormatSelectionForm: initialDocumentFormatSelectionForm
  })
})

export default reducers
